import axios from './axios';

const getSingleton = singleton => axios.get(`singletons/get/${singleton}`);

export default {
  getSingleton: getSingleton
}